export default __webpack_public_path__ + "static/media/logo-vn.ce0222ca.png";